import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SystemApiClient } from '../clients/system-api/SystemApiClientp';
import { PaginationArgs, TermDataAdministrationResult, TermData, AdministrationResultStatus, TermDataPaginationDataAdministrationResult, RetrieveGeneratedTimeSlotsData, TermDataListAdministrationResult, AddWorkingHoursDailyConfigs, TermSearchArgs, ServiceData } from '../clients/system-api/SystemApiClient';
@Injectable({
  providedIn: 'root'
})
export class TermService {
  constructor(private systemApiClient: SystemApiClient) { }

  retrieveAllTerms(body: PaginationArgs | undefined): Observable<TermDataPaginationDataAdministrationResult>  {
    return this.systemApiClient.retrieveAllTerms(body);
  }
  
  retrieveTermById(termId: number | undefined): Observable<TermDataAdministrationResult> {
    return this.systemApiClient.retrieveTermById(termId);
  }

  editTerm(body: TermData | undefined): Observable<AdministrationResultStatus> {
    return this.systemApiClient.editTerm(body);
  }

  cancelTerm(termId: number | undefined): Observable<AdministrationResultStatus> {
    return this.systemApiClient.cancelTerm(termId);
  }

  retrieveGeneratedTimeSlots(body: RetrieveGeneratedTimeSlotsData | undefined): Observable<TermDataListAdministrationResult> {
    return this.systemApiClient.retrieveGeneratedTimeSlots(body);
  }

  retrieveNegatedTermsByWorkingHoursDailyConfigs(body: AddWorkingHoursDailyConfigs | undefined): Observable<TermDataListAdministrationResult> {
    return this.systemApiClient.retrieveNegatedTermsByWorkingHoursDailyConfigs(body);
  }

  retrieveNegatedTermsByServiceRemoval(body: ServiceData[] | undefined): Observable<TermDataListAdministrationResult> {
    return this.systemApiClient.retrieveNegatedTermsByServiceRemoval(body);
  }

  retrieveTermsByTermSearchArgs(body: TermSearchArgs | undefined): Observable<TermDataListAdministrationResult> {
    return this.systemApiClient.retrieveTermsByTermSearchArgs(body);
  }
}